(function () {

  'use strict';

  function pxCreateWorkflowDialog() {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        onDone: '&'
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/createWorkflowDialog.template.html',
      link: function (scope, element, attributes) {

        scope.channel = {
          onValidityChange: function (isValid) {
            scope.isWorkflowFormValid = isValid;
          }
        };

        scope.onConfirmCreateWorkflow = async function () {
          const success = await scope.channel.createWorkflow();
          if (success) {
            scope.onDone();
          }
        };

        scope.onCancelCreateWorkflow = function () {
          scope.channel.cancelWorkflow();
          scope.onDone();
        };

      }
    };
  }

  pxCreateWorkflowDialog.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxCreateWorkflowDialog', pxCreateWorkflowDialog);

})();
